import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";

export type OtpInitialStateTypes = {
  duration: number;
  username: string;
};

const initialState = {
  duration: 120,
  username: "",
} as OtpInitialStateTypes;

export const otpSlice = createSlice({
  name: "otpSlice",
  initialState,
  reducers: {
    setDuration: (state, action: PayloadAction<number>) => {
      state.duration = action.payload;
    },
    setUsername: (state, action: PayloadAction<string>) => {
      state.username = action.payload;
    },
  },
});

export const useOtp = () => {
  const dispatch = useAppDispatch();
  const otpData = useAppSelector((state) => state.otp);

  const dispatchSetDuration = useCallback(
    (duration: number) => {
      dispatch(otpSlice.actions.setDuration(duration));
    },
    [dispatch],
  );

  return {
    dispatchSetDuration,
    otpData,
  };
};

export const { setDuration, setUsername } = otpSlice.actions;

export default otpSlice.reducer;
